var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#6b7280",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, "Business Plan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.3,74.5c1,0,1.8-0.8,1.8-1.8l0.1-20.8c0.1-1-0.8-1.8-1.6-1.9l-0.3,0l-20.9,0c-1-0.1-1.8,0.8-1.9,1.6 v0.3v3.8c-0.1,1,0.8,1.8,1.6,1.9h0.3h6.6c0.7,0,1.3,0.6,1.3,1.3c0,0.3-0.1,0.7-0.3,0.9l-14,14c-0.8,0.8-0.8,2.1-0.1,2.8l2.7,2.7 c0.8,0.7,2,0.6,2.8-0.1l14.1-14.1c0.5-0.5,1.3-0.5,1.8,0c0.2,0.2,0.4,0.5,0.3,0.9v6.6c-0.1,1,0.8,1.8,1.6,1.9h0.3L48.3,74.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,77.7c5.7-1,11.2-3.7,15.6-8c11.3-11.3,11.3-29.7,0-41s-29.7-11.3-41,0c-4.4,4.4-7,9.8-8,15.5l5.9,0 c0.9-4.2,3-8.1,6.2-11.4c9-9,23.8-9,32.8,0s9,23.8,0,32.8c-3.2,3.2-7.2,5.3-11.3,6.2L55.7,77.7z M56,65.8c2.6-0.8,5.1-2.2,7.1-4.3 c6.8-6.8,6.8-17.8,0-24.6s-17.8-6.8-24.6,0c-2.1,2.1-3.5,4.6-4.3,7.2l6.2,0c0.5-1.2,1.3-2.2,2.2-3.2c4.5-4.5,11.9-4.5,16.4,0 s4.5,11.9,0,16.4c-0.9,0.9-1.9,1.6-3,2.2L56,65.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.235d7be9260468c4593beb6fb6ec074e.svg";
export { ForwardRef as ReactComponent };